import * as types from '@/store/mutationTypes';

export const mutations = {
    [types.SET_LOADING] (state, value) {
        state.isLoading = value;
    },

    [types.SET_PROGRESS] (state, value) {
        state.isProgress = value;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/spinner/mutations.js